import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../_model/api-response';
import { UserNotificationDto, UserNotificationSummaryDto } from '../_model/additional-documents';

@Injectable({ providedIn: 'root' })
export class UserNotificationsService {
  private readonly base = environment.apiBaseUrl;
  private readonly summarySubject = new BehaviorSubject<UserNotificationSummaryDto>({ total: 0, unread: 0 });

  readonly summary$ = this.summarySubject.asObservable();

  constructor(private http: HttpClient) {}

  getNotifications(isRead: boolean | null, page = 1, size = 20): Observable<ApiResponse<UserNotificationDto[]>> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (isRead !== null) params = params.set('isRead', isRead);

    return this.http.get<ApiResponse<UserNotificationDto[]>>(
      `${this.base}/notifications`,
      { params }
    );
  }

  refreshSummary(): void {
    this.http.get<ApiResponse<UserNotificationSummaryDto>>(`${this.base}/notifications/summary`)
      .subscribe({
        next: response => this.summarySubject.next(response.data || { total: 0, unread: 0 }),
        error: () => this.summarySubject.next({ total: 0, unread: 0 })
      });
  }

  markRead(notificationId: string): Observable<ApiResponse<unknown>> {
    return this.http.post<ApiResponse<unknown>>(
      `${this.base}/notifications/${notificationId}/read`,
      {}
    ).pipe(tap(() => this.refreshSummary()));
  }

  markAllRead(): Observable<ApiResponse<unknown>> {
    return this.http.post<ApiResponse<unknown>>(
      `${this.base}/notifications/read-all`,
      {}
    ).pipe(tap(() => this.refreshSummary()));
  }

  reset(): void {
    this.summarySubject.next({ total: 0, unread: 0 });
  }
}
